<div class="spinner" [ngClass]="class">
	<div class="spinner-border"></div>
	<div class="spinner-text text-uppercase font-weight-light">{{ message }}</div>
</div>
